import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@material-ui/core';
import {FC} from 'react';
import {SSNData} from './SSN';

interface SSNTableProps {
    data: SSNData[];
}

const flagIndicators = [
    'does not',
    'likely',
    'was issued prior',
    'Match to full name and address using SSN Finder',
    'Consumer not on file – no record',
    'not deceased however no name match is available',
    'Invalid/No match – Legacy',
];

export const SSNTable: FC<SSNTableProps> = ({data}) => (
    <>
        <h4>Verification Result</h4>
        {data != null && data.length > 0 && (
            <TableContainer component={Paper}>
                <Table style={{minWidth: '100%'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Verification</TableCell>
                            <TableCell>Result</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((r) => (
                            <TableRow
                                key={r.name}
                                {...(r.name.includes('FraudShield') && {
                                    style: {backgroundColor: 'red'},
                                })}
                            >
                                <TableCell>{r.name}</TableCell>
                                <TableCell
                                    {...(r.value != null &&
                                        flagIndicators.some((flagWord) =>
                                            r.value.toLowerCase().includes(flagWord.toLowerCase()),
                                        ) && {
                                            style: {backgroundColor: 'red', fontWeight: 'bold'},
                                        })}
                                >
                                    {r.value}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        )}
    </>
);
